export enum Routenames {
    checkpoints = 'checkpoints',
    companies = 'companies',
    daily = 'daily',
    financials = 'financials',
    leave = 'leave',
    login = 'login',
    logout = 'logout',
    pdf = 'pdf',
    underlay = 'briefpapier',
    platforms = 'platforms',
    profile = 'profiel',
    registration = 'registration',
    reports = 'reports',
    rightsMatrix = 'rechtenmatrix',
    seire = 'seire',
    subscriptions = 'subscriptions',
    users = 'users',
    weekly = 'weekly',
    werkenBij = 'werken-bij',
}
